
export default {
  name: 'EuropeanUnionIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
